<p-inputNumber
  [(ngModel)]="numVal"
  [min]="minVal"
  class="form-control form-control-sm"
  [disabled]="disableField"
  [max]="maxVal"
  [attr.id]="element.name"
  (onInput)="valueChange($event)"
  (onFocus)="onFocus()"
  (onBlur)="onBlur()"
  maxlength="16"
></p-inputNumber>
